import home from './src/home.vue'
import CarShipManagerView from './src/CarShipManager/CarShipManagerView.vue' //车船基本信息管理列表
import CarShipManagerInfo from './src/CarShipManager/CarShipManagerInfo.vue' //车船基本信息管理详情
import LineManagerView from './src/LineManager/LineManagerView.vue' //线路管理列表
import LineManagerInfo from './src/LineManager/LineManagerInfo.vue' //线路管理详情
import StationManagerView from './src/StationManager/StationManagerView.vue' //站台管理列表
import StationManagerInfo from './src/StationManager/StationManagerInfo.vue' //站台管理详情
import LineStationManagerView from './src/LineStationManager/LineStationManagerView.vue' //线路站台管理列表
import LineStationManagerInfo from './src/LineStationManager/LineStationManagerInfo.vue' //线路站台管理详情

let views = {
    home,
    CarShipManagerView,
    CarShipManagerInfo,
    LineManagerView,
    LineManagerInfo,
    StationManagerView,
    StationManagerInfo,
    LineStationManagerView,
    LineStationManagerInfo
};

export default views;